import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TreatmentType } from "../../models/TreatmentProviders.models";

export interface SupportAndHealthServices {
    id: number;
    name: string;
    website: string;
    serviceType: string;
}

@Component({
  selector: 'app-support-and-health-services-list-item',
  templateUrl: './support-and-health-services-list-item.component.html',
  // styleUrls: ['./support-and-health-services-list-item.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class SupportAndHealthServicesListItemComponent implements OnInit {
  @Input() provider: SupportAndHealthServices;
  @Output() showProviderEvent: EventEmitter<SupportAndHealthServices> = new EventEmitter();

  readonly TreatmentType = TreatmentType;

  ngOnInit(): void {
    // if (this.treatmentProvider.city) {
    //   this.CityState += this.treatmentProvider.city;
    //   if (this.treatmentProvider.state) {
    //     this.CityState += ", ";
    //     this.CityState += this.treatmentProvider.state;
    //   }
    // } else {
    //   if (this.treatmentProvider.state) {
    //     this.CityState += this.treatmentProvider.state;
    //   }
    // }
  }
}
